import * as Yup from "yup";
import { KeyValueMap } from "../../../redux/slices/appState/models";
import { ActivitySearchFormKey } from "./models";
import { INPUT_LIMIT } from "../../../helpers/constants";

export const SearchMdmActivitySchema = (
  commonValidationMessages: KeyValueMap,
) =>
  Yup.object().shape({
    [ActivitySearchFormKey.activityType]: Yup.string()
      .matches(
        INPUT_LIMIT.ALPHA_NUMERIC_WITH_SOME_SPECIAL_CHAR,
        commonValidationMessages.onlyAlphanumericSpacesAllowed,
      )
      .default(""),
    [ActivitySearchFormKey.activityTypeFilter]: Yup.string().default(""),
    [ActivitySearchFormKey.topic]: Yup.string()
      .matches(
        INPUT_LIMIT.ALPHA_NUMERIC_WITH_SOME_SPECIAL_CHAR,
        commonValidationMessages.onlyAlphanumericSpacesAllowed,
      )
      .default(""),
    [ActivitySearchFormKey.topicFilter]: Yup.string().default(""),
    [ActivitySearchFormKey.activityStatus]: Yup.string().default(""),
    [ActivitySearchFormKey.programFramework]: Yup.string().default(""),
  });
